import { Expose, Transform, Type } from 'class-transformer';
import {
    BasketPriceModel,
    ProductModel,
    StockTypes,
    DeliveryPointOfServiceModel,
    AvailableSofaglideModel,
    LinkedSofaglideModel
} from 'models/Basket';

const DWELL_PART_NAME = 'DWELL';

export class BasketItemModel {
    @Type(() => ProductModel)
    public product: ProductModel;

    public range: string | null = null;

    public bcop: string;

    public scoopImage: string;

    public stockType: string;

    public swatchColour: string;

    public swatchName: string;

    public quantity: number;

    public entryNumber: number;

    public materialSubType: string;

    public webDescription: string;

    @Expose({ name: 'sofaShieldQuantity' })
    public sofashieldQuantity: number;

    @Type(() => BasketPriceModel)
    public basePrice: BasketPriceModel;

    @Type(() => BasketPriceModel)
    public savingsPrice: BasketPriceModel;

    @Type(() => BasketPriceModel)
    public totalPrice: BasketPriceModel;

    @Type(() => DeliveryPointOfServiceModel)
    public deliveryPointOfService: DeliveryPointOfServiceModel | null = null;

    @Expose({ name: 'availableSofaGlides' })
    @Transform(val => (val ? val : []))
    @Type(() => AvailableSofaglideModel)
    public availableSofaglides: AvailableSofaglideModel[];

    @Expose({ name: 'linkedSofaGlide' })
    @Transform(val => (val ? val : null))
    @Type(() => LinkedSofaglideModel)
    public linkedSofaglide: LinkedSofaglideModel | null;

    public hasStockType(stockType: StockTypes): boolean {
        return stockType === this.getStockType();
    }

    public shouldUpdateLinkedSofaglide(): boolean {
        if (this.linkedSofaglide) {
            return this.linkedSofaglide?.quantity !== this.quantity;
        }

        return false;
    }

    public hasDiscount(): boolean {
        return this.savingsPrice?.value > 0;
    }

    public isDwell(): boolean {
        return Boolean(this.range?.includes(DWELL_PART_NAME)) || Boolean(this.product.name?.includes(DWELL_PART_NAME));
    }

    public isQuickstock(): boolean {
        return this.stockType === 'Quick Stock';
    }

    private getStockType(): StockTypes {
        if (this.stockType === 'Ex-Display') {
            return StockTypes.ExDisplay;
        }

        if (this.stockType?.includes('Refurbished')) {
            return StockTypes.Refurbished;
        }

        return StockTypes.Default;
    }
}